import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Input from "../../shared/Input";
import InputWithlabelin from "../../shared/InputWithlabelin";
import Selectbox from "../../shared/Select";

const WelfareForm = ({ setwelfarearray, index, welfarearray, isFirst }) => {
  const {
    handleSubmit,
    formState: { errors, isValid },
    control,
    reset
  } = useForm();
  const faselezamani = [
    {
      value: 1,
      label: "5 دقیقه"
    },
    {
      value: 2,
      label: "۳۰ دقیقه"
    }
  ];

  console.log(welfarearray);
  // {
  //     name: "",
  //     distance_by_car: "",
  //     walking_distance: ""
  //   }
  return (
    <div className="createsteps--grid3 mt-[50px] placeform">
      <div className="Input seconadary-input">
        <label>نام مکان تفریحی ( اختیاری )</label>
        <input
          value={isFirst ? "" : welfarearray[index].name}
          placeholder="دریا ، دریاچه ، کافی شاپ و ..."
          onChange={e => {
            const updatedWelfare = {
              ...welfarearray[index],
              name: e.target.value
            };
            welfarearray.splice(index, 1);

            setwelfarearray([
              ...welfarearray.slice(0, index),
              updatedWelfare,
              ...welfarearray.slice(index + 1)
            ]);
          }}
        />
      </div>
      
      <div className={`InputWithlabelin relative `}>
        <label className="d-flex">فاصله زمانی با ماشین ( اختیاری )</label>
        <div className="flex InputWithlabelin--Inputbox">
          {" "}<input
          value={isFirst ?
          
            "":welfarearray[index].distance_by_car}
           placeholder="تعیین کنید"
            type="number"
            onChange={e => {
              const updatedWelfare = {
                ...welfarearray[index],
                distance_by_car: e.target.value
              };
              welfarearray.splice(index, 1);

              setwelfarearray([
                ...welfarearray.slice(0, index),
                updatedWelfare,
                ...welfarearray.slice(index + 1)
              ]);
            }}
          />
          <div className="InputWithlabelin--labelin">دقیقه</div>
        </div>
      </div>

         <div className={`InputWithlabelin relative `}>
        <label className="d-flex">فاصله زمانی پیاده ( اختیاری )</label>
        <div className="flex InputWithlabelin--Inputbox">
          {" "}<input
         value={isFirst ? "" : welfarearray[index].walking_distance}
           placeholder="تعیین کنید"
            type="number"
            onChange={e => {
              const updatedWelfare = {
                ...welfarearray[index],
                walking_distance: e.target.value
              };
              welfarearray.splice(index, 1);
    
              setwelfarearray([
                ...welfarearray.slice(0, index),
                updatedWelfare,
                ...welfarearray.slice(index + 1)
              ]);
            }}
          />
          <div className="InputWithlabelin--labelin">دقیقه</div>
        </div>
      </div>
    </div>
  );
};

export default WelfareForm;
